export const GET_PLAYER_PROFILES = "GET_PLAYER_PROFILES";
export const GET_PLAYER_PROFILES_SUCCESS = "GET_PLAYER_PROFILES_SUCCESS";
export const GET_PLAYER_PROFILES_FAIL = "GET_PLAYER_PROFILES_FAIL";

export const GET_PLAYER_PROFILE_DETAILS = "GET_PLAYER_PROFILE_DETAILS";
export const GET_PLAYER_PROFILE_DETAILS_SUCCESS = "GET_PLAYER_PROFILE_DETAILS_SUCCESS";
export const GET_PLAYER_PROFILE_DETAILS_FAIL = "GET_PLAYER_PROFILE_DETAILS_FAIL";

export const GET_PLAYER_PROFILE_ENTRIES = "GET_PLAYER_PROFILE_ENTRIES";
export const GET_PLAYER_PROFILE_ENTRIES_SUCCESS = "GET_PLAYER_PROFILE_ENTRIES_SUCCESS";
export const GET_PLAYER_PROFILE_ENTRIES_FAIL = "GET_PLAYER_PROFILE_ENTRIES_FAIL";

export const GET_DISTINCT_PLAYERS = "GET_DISTINCT_PLAYERS";
export const GET_DISTINCT_PLAYERS_SUCCESS = "GET_DISTINCT_PLAYERS_SUCCESS";
export const GET_DISTINCT_PLAYERS_FAIL = "GET_DISTINCT_PLAYERS_FAIL";

export const SEARCH_PLAYERS_WITH_SUGGESTIONS = "SEARCH_PLAYERS_WITH_SUGGESTIONS";
export const SEARCH_PLAYERS_WITH_SUGGESTIONS_SUCCESS = "SEARCH_PLAYERS_WITH_SUGGESTIONS_SUCCESS";
export const SEARCH_PLAYERS_WITH_SUGGESTIONS_FAIL = "SEARCH_PLAYERS_WITH_SUGGESTIONS_FAIL";

export const GET_PLAYER_PROFILE_STATS = "GET_PLAYER_PROFILE_STATS";
export const GET_PLAYER_PROFILE_STATS_SUCCESS = "GET_PLAYER_PROFILE_STATS_SUCCESS";
export const GET_PLAYER_PROFILE_STATS_FAIL = "GET_PLAYER_PROFILE_STATS_FAIL";

export const SET_SEARCH_TERM = "SET_SEARCH_TERM";
export const SET_DATE_RANGE = "SET_DATE_RANGE";
export const CLEAR_DATE_FILTER = "CLEAR_DATE_FILTER";

export const SET_SORT_KEY = "SET_SORT_KEY";
export const SET_SORT_DIRECTION = "SET_SORT_DIRECTION";

export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
export const SET_ITEMS_PER_PAGE = "SET_ITEMS_PER_PAGE";

export const SET_MODAL_STATE = "SET_MODAL_STATE";
export const SET_LOADING_STATE = "SET_LOADING_STATE";

export const SET_PLAYER_PROFILE_DATA = "SET_PLAYER_PROFILE_DATA";
export const SET_PLAYER_PROFILE_DATA_SUCCESS = "SET_PLAYER_PROFILE_DATA_SUCCESS";
export const SET_PLAYER_PROFILE_DATA_FAIL = "SET_PLAYER_PROFILE_DATA_FAIL";

export const SET_PLAYER_PROFILE_ENTRIES_DATA = "SET_PLAYER_PROFILE_ENTRIES_DATA";
export const SET_PLAYER_PROFILE_ENTRIES_DATA_SUCCESS = "SET_PLAYER_PROFILE_ENTRIES_DATA_SUCCESS";
export const SET_PLAYER_PROFILE_ENTRIES_DATA_FAIL = "SET_PLAYER_PROFILE_ENTRIES_DATA_FAIL";

export const SET_PLAYER_PROFILE_STATS_DATA = "SET_PLAYER_PROFILE_STATS_DATA";
export const SET_PLAYER_PROFILE_STATS_DATA_SUCCESS = "SET_PLAYER_PROFILE_STATS_DATA_SUCCESS";
export const SET_PLAYER_PROFILE_STATS_DATA_FAIL = "SET_PLAYER_PROFILE_STATS_DATA_FAIL";

export const SET_ALL_PLAYERS = "SET_ALL_PLAYERS";
export const SET_PLAYER_PROFILE_STATS = "SET_PLAYER_PROFILE_STATS";
export const SET_LOADING = "SET_LOADING";
export const SET_STATS_LOADING = "SET_STATS_LOADING";
export const SET_ERROR = "SET_ERROR";


// Action creators
export const getPlayerProfiles = () => ({
  type: GET_PLAYER_PROFILES
});

export const getPlayerProfileById = (id) => ({
  type: GET_PLAYER_PROFILE_DETAILS,
  payload: id
});

export const getPlayerProfileEntries = (playerNumber) => ({
  type: GET_PLAYER_PROFILE_ENTRIES,
  payload: playerNumber
});

export const setAllPlayers = (players) => ({
  type: SET_ALL_PLAYERS,
  payload: players
});

export const setPlayerProfileStats = (stats) => ({
  type: SET_PLAYER_PROFILE_STATS,
  payload: stats
});

export const setLoading = (loading) => ({
  type: SET_LOADING,
  payload: loading
});

export const setStatsLoading = (loading) => ({
  type: SET_STATS_LOADING,
  payload: loading
});

export const setError = (error) => ({
  type: SET_ERROR,
  payload: error
});

export const setCurrentPage = (page) => ({
  type: SET_CURRENT_PAGE,
  payload: page
});

export const setItemsPerPage = (itemsPerPage) => ({
  type: SET_ITEMS_PER_PAGE,
  payload: itemsPerPage
});

export const getDistinctPlayers = (page, limit, search, startDate, endDate) => ({
  type: GET_DISTINCT_PLAYERS,
  payload: { page, limit, search, startDate, endDate }
});
